import { Card, Icon, Typography } from '@repo/ui';
import { ButtonColors, ButtonVariants, LinkButton } from 'components';
import { useState } from 'react';
import {
  HOW_TO_USE_BODY,
  HOW_TO_USE_TITLE,
  VIEW_ACTION_PLAN_LABEL,
} from './utils/conditionDetailCopy';
import styles from './ConditionHowToUseCard.module.css';

export const ConditionHowToUseCard = ({ kitId }: { kitId: string }) => {
  const [expanded, setExpanded] = useState(true);
  const paragraphs = HOW_TO_USE_BODY.split('\n\n');

  return (
    <Card variant='wrapper'>
      <div className={styles.inner}>
        <div
          className={styles.header}
          role='button'
          tabIndex={0}
          aria-expanded={expanded}
          onClick={() => setExpanded(prev => !prev)}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setExpanded(prev => !prev);
            }
          }}
        >
          <Typography variant='heading-m' className={styles.title}>
            {HOW_TO_USE_TITLE}
          </Typography>
          <Icon name={expanded ? 'chevronUp' : 'chevronDown'} size='m' />
        </div>
        {expanded && (
          <div className={styles.body}>
            {paragraphs.map((paragraph, index) => (
              <Typography key={index} variant='body-s' className={styles.text}>
                {paragraph}
              </Typography>
            ))}
            <LinkButton
              href={`/action-plan/${kitId}`}
              label={VIEW_ACTION_PLAN_LABEL}
              color={ButtonColors.PURPLE}
              variant={ButtonVariants.SOLID}
              width='full'
              linkClassName={styles.actionLink}
            />
          </div>
        )}
      </div>
    </Card>
  );
};
